var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyStructure2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 97,
    viewBox: "0 0 110 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4644 96.2036L91.9528 96.2036C101.778 96.2036 109.742 88.2498 109.742 78.4384C109.742 68.6269 101.778 60.6731 91.9528 60.6731L18.4644 60.6731C8.63958 60.6731 0.67498 68.6269 0.67498 78.4384C0.67498 88.2498 8.63958 96.2036 18.4644 96.2036Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61073 0.841797H101.806C104.269 0.841797 106.069 5.02706 105.405 9.27126L99.505 48.2796C98.2364 56.8417 93.9144 62.7365 88.9729 62.7365H21.4439C16.5024 62.7365 12.1952 56.8417 10.8971 48.3239L4.99679 9.31547C4.34776 5.02706 6.14735 0.841797 8.61073 0.841797Z",
    fill: "#3098F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyStructure2);
export default __webpack_public_path__ + "static/media/body-structure2.4ab08735d436b492b44c41984d0e16f5.svg";
export { ForwardRef as ReactComponent };